import InputField from '../inputs/InputField';
import { connect } from 'react-redux';
import { otherBlur, otherChange } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    isValid: !!question.isOtherValid,
    value: question.otherValue,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => dispatch(otherChange(e.target.value, ownProps.questionId)),
  onBlur: () => dispatch(otherBlur(ownProps.questionId)),
});

const OtherField = connect(mapStateToProps, mapDispatchToProps)(InputField);

export default OtherField;
